// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"814":"47699738","849":"b1811655"}[chunkId] + ".chunk.js";
};